import { FLOOR_MAP } from "@/IPA/Floors";

export function normalizeFloorValue(raw) {
	if (raw === null || raw === undefined) return "";
	const text = String(raw).trim();
	if (!text) return "";
	if (/^-?\d+$/.test(text)) return String(Number(text));
	return text;
}

export function isNumericFloor(raw) {
	return /^-?\d+$/.test(normalizeFloorValue(raw));
}

export function floorDisplayLabel(raw) {
	const normalized = normalizeFloorValue(raw);
	if (!normalized) return "Nepozitionat";
	if (isNumericFloor(normalized)) {
		const value = Number(normalized);
		return FLOOR_MAP[value] || `Etaj ${normalized}`;
	}
	return normalized;
}

export function floorSortKey(raw) {
	const normalized = normalizeFloorValue(raw);
	if (!normalized) return [2, ""];

	const lowered = normalized.toLowerCase();
	const isMansarda =
		normalized === "3" ||
		lowered.includes("mansard");
	if (isMansarda) return [3, Number.POSITIVE_INFINITY];

	if (isNumericFloor(normalized)) return [0, Number(normalized)];

	// If custom text contains a number (e.g. "etaj 12", "nivel B2"),
	// include it in sorting to keep a natural ascending order.
	const embeddedNumberMatch = lowered.match(/-?\d+/);
	if (embeddedNumberMatch) {
		return [1, Number(embeddedNumberMatch[0])];
	}

	return [2, lowered];
}
